import { Platform, useColorScheme } from 'react-native';

import { shadow } from './tokens.generated';

type Level = 1 | 2;

// Web (and RN's own boxShadow) takes the CSS string; native uses the iOS shadow
// props plus Android elevation, because RN cannot express a negative spread.
export function shadowStyle(level: Level, dark: boolean, web: boolean) {
  const { boxShadow, ...native } = shadow[dark ? 'dark' : 'light'][level];
  return web ? { boxShadow } : native;
}

export function useShadow(level: Level) {
  return shadowStyle(level, useColorScheme() === 'dark', Platform.OS === 'web');
}
